import { p as palette } from '../base/color-DMp1DFwP.js';
import { m as mobileSpacing } from '../base/spacing-zNVNrnl_.js';
import { t as typography, d as fontSizes, m as mobileFontSizes } from '../base/typography-j1qfCKl5.js';

const searchInputStyles = {
  searchIconOpacity: 1,
  searchIconMarginRight: '8px',
  searchIconFontSize: fontSizes.base,
  searchIconColor: palette.gray[500],
  closeButtonFontSize: fontSizes.mini,
  closeButtonColor: typography.color.tertiary,
  closeButtonColorHover: palette.squidInk,
  closeButtonPadding: '0 4px',
  closeButtonBorderRadius: '100%',
  closeButtonMargin: '0 0 0 2px'
};
const mobileSearchInputStyles = {
  mobile: {
    searchIconFontSize: mobileFontSizes.base,
    closeButtonFontSize: mobileFontSizes.base,
    closeButtonPadding: `9px ${mobileSpacing.small}`
  }
};

export { mobileSearchInputStyles as m, searchInputStyles as s };
//# sourceMappingURL=searchInput-DQA9YiST.js.map
